import React from 'react';
import './style.scss';
export default function <FunnelItem05>() {
	return (
		<div className='funnel-item-05-container'>
			<div className=''>Test Item 05</div>
		</div>
	);
}
